import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  educationCategoryList: [],
  educationCategoryFormList: [],
  educationCategoryAllList: [],
  educationCategoryDetail: [],
  loading: false,
  error: undefined,
};

const educationCategorySlice = createSlice({
  name: "educationCategory",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchEducationCategoryList(state, action) {
      state.educationCategoryList = action.payload;
      state.loading = false;
    },
    fetchEducationCategoryFormList(state, action) {
      state.educationCategoryFormList = action.payload;
      state.loading = false;
    },
    fetchEducationCategoryAllList(state, action) {
      state.educationCategoryAllList = action.payload;
      state.loading = false;
    },
    fetchEducationCategoryDetail(state, action) {
      state.educationCategoryDetail = action.payload;
      state.loading = false;
    },
  },
});

export const educationCategoryActions = educationCategorySlice.actions;

export default educationCategorySlice.reducer;
